/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Contact_SalesInputs */

const en_nfp_contact_sales = /** @type {(inputs: Nfp_Contact_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Impact Team`)
};

const es_nfp_contact_sales = /** @type {(inputs: Nfp_Contact_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactar al Equipo de Impacto`)
};

const fr_nfp_contact_sales = /** @type {(inputs: Nfp_Contact_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacter l'équipe Impact`)
};

const de_nfp_contact_sales = /** @type {(inputs: Nfp_Contact_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impact-Team kontaktieren`)
};

const id_nfp_contact_sales = /** @type {(inputs: Nfp_Contact_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi Tim Dampak`)
};

/** @type {(inputs: Nfp_Contact_SalesInputs) => LocalizedString} */
const ja_nfp_contact_sales = en_nfp_contact_sales;

/** @type {(inputs: Nfp_Contact_SalesInputs) => LocalizedString} */
const zh_nfp_contact_sales = en_nfp_contact_sales;

/** @type {(inputs: Nfp_Contact_SalesInputs) => LocalizedString} */
const ar_nfp_contact_sales = en_nfp_contact_sales;

/** @type {(inputs: Nfp_Contact_SalesInputs) => LocalizedString} */
const it_nfp_contact_sales = en_nfp_contact_sales;

/** @type {(inputs: Nfp_Contact_SalesInputs) => LocalizedString} */
const ru_nfp_contact_sales = en_nfp_contact_sales;

/** @type {(inputs: Nfp_Contact_SalesInputs) => LocalizedString} */
const pt_nfp_contact_sales = en_nfp_contact_sales;

/** @type {(inputs: Nfp_Contact_SalesInputs) => LocalizedString} */
const ko_nfp_contact_sales = en_nfp_contact_sales;

/**
* | output |
* | --- |
* | "Contact Impact Team" |
*
* @param {Nfp_Contact_SalesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_contact_sales = /** @type {((inputs?: Nfp_Contact_SalesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Contact_SalesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_contact_sales(inputs)
	if (locale === "es") return es_nfp_contact_sales(inputs)
	if (locale === "fr") return fr_nfp_contact_sales(inputs)
	if (locale === "de") return de_nfp_contact_sales(inputs)
	if (locale === "ja") return ja_nfp_contact_sales(inputs)
	if (locale === "zh") return zh_nfp_contact_sales(inputs)
	if (locale === "ar") return ar_nfp_contact_sales(inputs)
	if (locale === "id") return id_nfp_contact_sales(inputs)
	if (locale === "it") return it_nfp_contact_sales(inputs)
	if (locale === "ru") return ru_nfp_contact_sales(inputs)
	if (locale === "pt") return pt_nfp_contact_sales(inputs)
	return ko_nfp_contact_sales(inputs)
});